import { Dialog, IconButton, Box } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

interface VideoModalProps {
    open: boolean
    onClose: () => void
    videoId: string
    title?: string
    aspectRatio?: string // CSS paddingTop; defaults to 16:9
}

export function VideoModal({ open, onClose, videoId, title = 'Product demo', aspectRatio = '56.25%' }: VideoModalProps) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth='md'
            fullWidth
            PaperProps={{ sx: { backgroundColor: 'black', m: { xs: 1, md: 2 }, overflow: 'visible' } }}
        >
            <IconButton
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    top: -16,
                    right: -16,
                    backgroundColor: 'white',
                    color: 'black',
                    zIndex: 1,
                    '&:hover': { backgroundColor: 'rgba(255,255,255,0.85)' },
                }}
                size="small"
            >
                <CloseIcon fontSize="small" />
            </IconButton>
            <Box sx={{ position: 'relative', paddingTop: aspectRatio }}>
                {open && (
                    <Box
                        component="iframe"
                        src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
                        title={title}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
                    />
                )}
            </Box>
        </Dialog>
    )
}
